import { MyPeople } from "../my-people/my-people";
import { MaMFormHandler } from "../../assets/js/MaMFormHandler.js";

/**
 * Get data for bootstrap table.
 * This function is configured in the boostrap-table (data-ajax="tableGetConditionsData")
 * @param {object} params - parameters for pagination, search etc.
 */
window.tableGetConditionsData = function (params) {
  let url =
    MaMFormHandler.getBaseUrl() +
    "/get-table/health-conditions?field=health-conditions";

  var qString = "&records=";
  $('.existing-inputs input[data-attr-key="' + params.data.key + '"]').each(
    function () {
      qString += $(this).val() + ",";
    }
  );

  if($(".health-conditions-component[data-attr-key='" + params.data.key + "']").attr('data-global-scope') == '1'){
    qString = "";
  }

  $.ajax({
    method: "GET",
    dataType: "json",
    url: url + "&" + $.param(params.data) + qString,
  })
    .done(function (data) {
      params.success(data);
    })
    .fail(function (err) {
      Util.toggleAlert(
        "#conditions-list-alert",
        "Could not fetch health conditions data",
        "alert-warning",
        -1
      );
    });
};

window.actionsDetailFormatter = function (value, row) {
  return `
    <a class="condition-info-modal" data-attr-id="${row.id}" data-attr-condition="${row.health_condition}">
        <svg class="bi action-icon" width="24" height="33" fill="currentColor">
          <use xlink:href="/static/images/bootstrap-icons.svg#info" />
        </svg>
      </a>
  `;
};

window.actionsDetailEvents = function () {
  return {
    "click .condition-info-modal": (e, value, row) => {
      e.stopPropagation();

      var key = $(e.target)
        .closest(".health-conditions-component")
        .attr("data-attr-key");

      var condition = row.health_condition;

      $.get({
        url:
          MaMFormHandler.getBaseUrl() +
          "/get-health-condition/" +
          condition.replace("Other: ", ""),
        headers: {
          "x-csrf-token":
            '{"csrf_name":"' +
            $("#csrf_name").val() +
            '","csrf_value":"' +
            $("#csrf_value").val() +
            '"}',
        },
        success: function (res) {
          if (res.success) {
            $(
              ".condition-description-modal[data-attr-key='" +
                key +
                "'] .condition-modal-content"
            ).html(res.content);
          } else {
            $(
              ".condition-description-modal[data-attr-key='" +
                key +
                "'] .condition-modal-content"
            ).html("No information available for this health condition.");
          }
        },
      });
      $(".condition-description-modal[data-attr-key='" + key + "']").modal(
        "show"
      );

      return false;
    },
  };
};

window.conditionDetailFormatter = function (idx, row) {
  return `
          <div class="row med-bs-detail-row" data-attr-row-idx="${idx}" data-attr-id="${row.id}">
            
            <div class="col-md-12 condition-search-container">
                <label class="label">Health Condition name
                    <input type="text" class="form-control med-name-other"
                        value="${row.health_condition}" placeholder="Type your Health Condition" name="health_condition_other" />

                    <div class="med-select d-none">
                        <small>Suggestions - click to choose:</small>
                        <ul class="med-search-list">
                        </ul>
                    </div>
                    <input class="form-control d-none" name="health_condition" />

                </label>
                <span class="mb-0 input-errors input-error-health_condition"></span>
            </div>
            <div class="col-md-12">
                <label class="label">Diagnosed
                    <input type="date" class="form-control" placeholder="Start"
                        name="diagnosis_date" value="${row.diagnosis_date}" />
                </label>
                <span class="mb-0 input-errors input-error-diagnosis_date"></span>
            </div>
            <div class="col-md-12">
                <label class="label">End
                    <input type="date" class="form-control" placeholder="Start"
                        name="condition_end_date" value="${row.condition_end_date}" />
                </label>
                <span class="mb-0 input-errors input-error-condition_end_date"></span>
            </div>

            
            <div class="col-md-12 controls-col">
                <a class="edit-row d-none">
                    <svg class="bi action-icon" width="15" height="23" fill="currentColor">
                        <use xlink:href="/static/images/bootstrap-icons.svg#pencil" />
                    </svg>
                </a>
                <a class="edit-row-expand-full btn btn-secondary" data-attr-id="${row.id}">
                    Expand
                </a>
                <a class="edit-row-save btn btn-primary">
                    Save
                </a>
                <a class="edit-row-cancel btn btn-outline">
                    Cancel
                </a>
            </td>

          </div>
  `;
};

/**
 * More about me main menu */
export const MyHealthConditions = (function () {
  var medicationSearchList = [];

  var csrfHeaders = function () {
    return {
      "x-csrf-token":
        '{"csrf_name":"' +
        $("#csrf_name").val() +
        '","csrf_value":"' +
        $("#csrf_value").val() +
        '"}',
    };
  };

  var medicationSearchList = [];
  $(".med-search-reference .medrecord").each(function () {
    medicationSearchList.push({
      id: $(this).attr("data-attr-val"),
      title: $(this).html(),
    });
  });

  var initConditionSearch = function () {
    var medicationSearchList = [];
    $(".med-search-reference .medrecord").each(function () {
      medicationSearchList.push({
        id: $(this).attr("data-attr-val"),
        title: $(this).html(),
      });
    });

    $(".med-name-other")
      .off("keyup")
      .on("keyup", function () {
        var parentElem = $(this).closest(".condition-search-container");

        var searchValue = $(this).val();
        var searchValueLength = searchValue.length;

        if (searchValueLength == 0) {
          $(parentElem).find(".med-select").addClass("d-none");
          $(parentElem).find(".med-search-list").html("");
          return false;
        } else {
          $(parentElem).find(".med-select").removeClass("d-none");
          $(parentElem).find(".med-search-list").html("");
        }

        var foundResult = false;

        medicationSearchList.forEach(function (val) {
          if (val.title.toLowerCase().includes(searchValue.toLowerCase())) {
            $(parentElem)
              .find(".med-search-list")
              .append(
                '<li data-attr-id="' +
                  val.id +
                  '" data-attr-val="' +
                  val.title +
                  '" class="medrecord">' +
                  val.title +
                  "</li>"
              );
            foundResult = true;
          }
        });
        if (!foundResult) {
          $(parentElem)
            .find(".med-search-list")
            .append("<li>No suggestions found</li>");
        }

        initConditionSearchClicks();
      });
  };

  var initConditionSearchClicks = function () {
    $(".medrecord")
      .off("click")
      .on("click", function () {
        var parentElem = $(this).closest(".condition-search-container");

        $(parentElem)
          .find('input[name="health_condition"]')
          .val($(this).attr("data-attr-val"));

        $(parentElem)
          .find('input[name="health_condition_other"]')
          .val($(this).attr("data-attr-val"));

        $(parentElem).find(".med-select").addClass("d-none");
      });
  };

  var setupRowExpand = function (rowId, key) {
    var dataRow = $('.med-bs-detail-row[data-attr-id="' + rowId + '"]');
    var editFull = $(".add-edit-record");
    
    key = 'embed___'+key+'___';

    $(".health-conditions-component .input-errors").html("");

    $.get({
      url:
        MaMFormHandler.getBaseUrl() +
        "/get-table/health-conditions?&field=health-conditions&row=" +
        rowId,
      headers: csrfHeaders(),
      success: function (res) {
        if (res.health_condition.substring(0, 6) == "Other:") {
          $(dataRow)
            .find("[name='health_condition_other']")
            .val(res.health_condition.split("Other: ")[1]);

          $(dataRow).find("[name='health_condition']").val("Other:");
        } else {
          $(dataRow)
            .find("[name='health_condition']")
            .val(res.health_condition);
        }

        $(dataRow)
          .find("[name='diagnosis_date']")
          .val(
            typeof res.diagnosis_date == "undefined" ? "" : res.diagnosis_date
          );
        $(dataRow)
          .find("[name='condition_end_date']")
          .val(
            typeof res.condition_end_date == "undefined"
              ? ""
              : res.condition_end_date
          );

        $(editFull)
          .find("[name='diagnosis_provider']")
          .val(
            typeof res.diagnosis_provider == "undefined"
              ? ""
              : res.diagnosis_provider
          );
        $(editFull)
          .find("[name='background_information']")
          .html(
            typeof res.background_information == "undefined"
              ? ""
              : res.background_information
          )
          .val(
            typeof res.background_information == "undefined"
              ? ""
              : res.background_information
          );

        $("#myPeopleContainer-prescriber_name .load-people").remove();

        MyPeople.clearTableKey(key+"diagnosis_provider");

        if (
          typeof res.diagnosis_provider != "undefined" &&
          res.diagnosis_provider != ""
        ) {
          $(editFull)
            .find("[name='"+key+"diagnosis_provider']")
            .val(
              typeof res.diagnosis_provider == "object" &&
                res.diagnosis_provider.length > 0
                ? res.diagnosis_provider[0].id
                : ""
            );

          if (
            typeof res.diagnosis_provider == "object" &&
            res.diagnosis_provider.length > 0
          ) {
            $("#myPeopleContainer-"+key+"diagnosis_provider").append(
              '<input type="hidden" data-attr-peopleid="' +
                res.diagnosis_provider[0].id +
                '" class="load-people" />'
            );
          }
          MyPeople.populateTableKey(key+"diagnosis_provider");
        }

        $(dataRow)
          .closest(".data-row")
          .find(".edit-mode")
          .removeClass("d-none");
      },
      dataType: "json",
    });
  };

  var initConditionDataClicks = function () {
    $(".health-conditions-component .edit-row-save")
      .off("click")
      .on("click", function (e) {
        var id = $(this).closest(".med-bs-detail-row").attr("data-attr-id");
        var dataRow = $(this).closest(
          '.med-bs-detail-row[data-attr-id="' + id + '"]'
        );
        $(".health-conditions-component .input-errors").html("");

        var payload = {};
        $(dataRow)
          .find("input,select")
          .each(function () {
            payload[$(this).attr("name")] = $(this).val();
          });

        var url =
          MaMFormHandler.getBaseUrl() + "/update-table-row/health-conditions";

        $.post({
          url: url + "?key=health-conditions&item-key=" + id,
          data: payload,
          headers: csrfHeaders(),
          success: function (res) {
            if (res.success) {
              $(".health-conditions-component .add-edit-record").addClass(
                "d-none"
              );
              $(".health-conditions-component .input-errors").html("");
              $(".read-mode").removeClass("d-none");

              $(".health-conditions-component")
                .find(".page-add-edit-control-row")
                .removeClass("d-none");

              $(".health-conditions-component .add-record-button").removeClass(
                "d-none"
              );

              $(".health-conditions-component .edit-record-button").addClass(
                "d-none"
              );

              $(".health-conditions-component")
                .find(".edit-details-title")
                .addClass("d-none");

              $(".table-conditions").bootstrapTable("refresh");
            } else {
              var message = res.message.split(": ");
              var errorField = message[0];
              var errorMessage = message[1];
              $(dataRow)
                .find(".input-error-" + errorField)
                .html(errorMessage);
            }
          },
          dataType: "json",
        });

        return false;
      });

    $(".health-conditions-component .save-record-cancel")
      .off("click")
      .on("click", function (e) {
        var itemKey = $(this).attr("data-attr-itemkey");
        var key = $(this)
          .closest(".health-conditions-component")
          .attr("data-attr-key");

        $('.condition-edit-modal[data-attr-key="' + key + '"]').modal("hide");
        $(this)
          .closest(".health-conditions-component")
          .find(".edit-record-button")
          .addClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".save-record-cancel")
          .addClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".remove-record")
          .addClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".add-record-button")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".page-add-edit-control-row")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".add-edit-record")
          .addClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".data-row[data-attr-id='" + itemKey + "'] .edit-row-save")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".data-row[data-attr-id='" + itemKey + "'] .read-mode")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(
            ".data-row[data-attr-id='" + itemKey + "'] .edit-row-expand-full"
          )
          .addClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".data-row[data-attr-id='" + itemKey + "'] .edit-row")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(
            ".data-row[data-attr-id='" + itemKey + "'] .condition-info-modal"
          )
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".data-row[data-attr-id='" + itemKey + "'] .edit-mode")
          .addClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".data-row[data-attr-id='" + itemKey + "'] .edit-row-save")
          .addClass("d-none");

        $(".health-conditions-component")
          .find(".edit-details-title")
          .addClass("d-none");

        return false;
      });

    $(".health-conditions-component .remove-record")
      .off("click")
      .on("click", function (e) {
        var itemKey = $(this).attr("data-attr-itemkey");
        var key = $(this)
          .closest(".health-conditions-component")
          .attr("data-attr-key");

        var elem = $(this);
        if (!confirm("Delete this health condition, are you sure?")) {
          return false;
        }

        var url =
          MaMFormHandler.getBaseUrl() +
          "/delete-table-row?type=health-conditions&id=" +
          itemKey;

        $.post({
          url: url,
          headers: csrfHeaders(),
          success: function (res) {
            $(elem)
              .closest(".health-conditions-component")
              .find(".edit-record-button")
              .addClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(".save-record-cancel")
              .addClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(".remove-record")
              .addClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(".add-record-button")
              .removeClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(".page-add-edit-control-row")
              .removeClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(".add-edit-record")
              .addClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(".data-row[data-attr-id='" + itemKey + "'] .edit-mode")
              .addClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(
                ".data-row[data-attr-id='" +
                  itemKey +
                  "'] .edit-row-expand-full"
              )
              .addClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(".data-row[data-attr-id='" + itemKey + "'] .edit-row-save")
              .addClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(
                ".data-row[data-attr-id='" +
                  itemKey +
                  "'] .condition-info-modal"
              )
              .removeClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(".data-row[data-attr-id='" + itemKey + "'] .edit-row")
              .removeClass("d-none");

            $(elem)
              .closest(".health-conditions-component")
              .find(".edit-details-title")
              .addClass("d-none");

            $('.condition-edit-modal[data-attr-key="' + key + '"]').modal(
              "hide"
            );
            $(".table-conditions").bootstrapTable("refresh");

            return false;
          },
          dataType: "json",
        });

        return false;
      });

    $(".health-conditions-component .save-record-button")
      .off("click")
      .on("click", function (e) {
        var itemKey = $(this).attr("data-attr-itemkey");
        var key = $(this)
          .closest(".health-conditions-component")
          .attr("data-attr-key");

        var payload = {};
        if (itemKey != "new") {
          var jqString =
            ".health-conditions-component[data-attr-key='" +
            key +
            "'] .edit-controls input, " +
            ".health-conditions-component[data-attr-key='" +
            key +
            "'] .edit-controls select, " +
            ".health-conditions-component[data-attr-key='" +
            key +
            "'] .edit-controls textarea, " +
            ".health-conditions-component[data-attr-key='" +
            key +
            "'] .med-bs-detail-row[data-attr-id='" +
            itemKey +
            "'] input, " +
            ".health-conditions-component[data-attr-key='" +
            key +
            "'] .med-bs-detail-row[data-attr-id='" +
            itemKey +
            "'] select";

          $(jqString).each(function () {
            if ($(this).hasClass("my-people-input")) {
              return;
            }
            if (!$(this).attr("name")) {
              return;
            }
            if (
              $(this).attr("name").includes("csrf") ||
              $(this).attr("name") == "undefined"
            ) {
              return;
            }
            payload[$(this).attr("name")] = $(this).val();
          });
        } else {
          var jqString =
            ".health-conditions-component[data-attr-key='" +
            key +
            "'] .add-controls input, .health-conditions-component .add-controls select, .health-conditions-component[data-attr-key='" +
            key +
            "'] .add-controls textarea";

          $(jqString).each(function () {
            if ($(this).hasClass("my-people-input")) {
              return;
            }
            if (!$(this).attr("name")) {
              return;
            }
            if (
              $(this).attr("name").includes("csrf") ||
              $(this).attr("name") == "undefined"
            ) {
              return;
            }
            payload[$(this).attr("name")] = $(this).val();
          });
        }


        $.each( payload, function( key, value ) {
          if(key.substr(0,5) == 'embed'){
            var origKey = key.split('___')[2];
            payload[origKey] = payload[key];
            delete payload[key];
          }
        });

        var url =
          MaMFormHandler.getBaseUrl() +
          "/add-table-row/health-conditions?item-key=" +
          itemKey;
        if (itemKey != "new") {
          url =
            MaMFormHandler.getBaseUrl() +
            "/update-table-row/health-conditions?key=health-conditions&item-key=" +
            itemKey;
        }

        $.post({
          url: url,
          data: payload,
          headers: csrfHeaders(),
          success: function (res) {
            if (!res.success) {
              var message = res.message.split(": ");
              var errorField = message[0];
              var errorMessage = message[1];

              Util.toggleAlert(
                ".alert",
                "Error: Please correct the form errors",
                "alert-warning"
              );

              $(".health-conditions-component .input-errors").html("");
              if (itemKey == "new") {
                $(
                  ".health-conditions-component .add-edit-record .input-error-" +
                    errorField
                ).html(errorMessage);
              } else {
                $(
                  ".health-conditions-component .input-error-" + errorField
                ).html(errorMessage); //detail-controls
                $(
                  ".health-conditions-component .data-row[data-attr-id='" +
                    itemKey +
                    "'] .input-error-" +
                    errorField
                ).html(errorMessage);
              }

              return;
            } else {
              if (itemKey == "new") {
                $(".health-conditions-component .add-edit-record").addClass(
                  "d-none"
                );
                $(".health-conditions-component .input-errors").html("");

                $(".health-conditions-component")
                  .find(".page-add-edit-control-row")
                  .removeClass("d-none");

                $(
                  ".health-conditions-component .add-record-button"
                ).removeClass("d-none");

                $(".health-conditions-component .edit-record-button").addClass(
                  "d-none"
                );
                $('.existing-inputs[data-attr-key="' + key + '"]').append(
                  '<input type="hidden" name="inputs[' +
                    key +
                    '][my_health_conditions][]" class="bsave bsave-multi" value="' +
                    res.response_data.last_insert_id +
                    '" data-attr-key="' +
                    key +
                    '" />'
                );
                MaMFormHandler.init();
                $(
                  '.existing-inputs[data-attr-key="' + key + '"] .bsave:first'
                ).trigger("blur");
              } else {
                $(".health-conditions-component .add-edit-record").addClass(
                  "d-none"
                );
                $(".health-conditions-component .input-errors").html("");

                $(".health-conditions-component")
                  .find(".page-add-edit-control-row")
                  .removeClass("d-none");

                $(".health-conditions-component .read-mode").removeClass(
                  "d-none"
                );

                $(
                  ".health-conditions-component .add-record-button"
                ).removeClass("d-none");

                $(".health-conditions-component .edit-record-button").addClass(
                  "d-none"
                );

                $(".health-conditions-component")
                  .find(".edit-details-title")
                  .addClass("d-none");
              }
              $('.condition-edit-modal[data-attr-key="' + key + '"]').modal(
                "hide"
              );
              $(".table-conditions").bootstrapTable("refresh");
            }
          },
          dataType: "json",
        });

        return false;
      });

    $(".health-conditions-component .edit-record")
      .off("click")
      .on("click", function (e) {
        //populate the data

        $(this)
          .closest(".health-conditions-component")
          .find(".add-edit-record")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".add-controls")
          .addClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".edit-controls")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".save-inline-row")
          .addClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".page-add-edit-control-row")
          .removeClass("d-none");

        var id = $(this).attr("data-attr-id");
        $(".edit-record-button").attr("data-attr-id", id);

        return false;
      });

    $(".health-conditions-component .edit-row-cancel")
      .off("click")
      .on("click", function (e) {
        $(this)
          .closest(".detail-view")
          .prev()
          .find(".detail-icon")
          .trigger("click");
        return false;
      });

    $(".health-conditions-component .edit-row-expand-full")
      .off("click")
      .on("click", function (e) {
        var key = $(this)
          .closest(".health-conditions-component")
          .attr("data-attr-key");

        $('.condition-edit-modal[data-attr-key="' + key + '"]').modal("show");
        $(".add-edit-record").removeClass("d-none");
        $(".add-edit-record .add-controls").addClass("d-none");

        var id = $(this).attr("data-attr-id");
        $(".page-add-edit-control-row .save-record-button").attr(
          "data-attr-itemkey",
          id
        );
        $(".page-add-edit-control-row .save-record-cancel").attr(
          "data-attr-itemkey",
          id
        );
        $(".page-add-edit-control-row .remove-record").attr(
          "data-attr-itemkey",
          id
        );

        $(this)
          .closest(".health-conditions-component")
          .find(".page-add-edit-control-row")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(
            ".page-add-edit-control-row .save-record-button, .page-add-edit-control-row .remove-record, .page-add-edit-control-row .save-record-cancel"
          )
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".edit-controls")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".my-people-small-mode")
          .removeClass("pt-my-people-adding-row");

        $(this)
          .closest(".health-conditions-component")
          .find(".edit-record-button")
          .addClass("d-none");

        return false;
      });
  };

  var init = function () {
    if ($(".health-conditions-component").length < 1) {
      return false;
    }

    $(".table-conditions").on(
      "expand-row.bs.table",
      function (e, index, row, $detail) {
        e.stopPropagation();
        setupRowExpand(row.id, e.target.getAttribute('data-attr-key'));
        initConditionSearch();
        initConditionDataClicks();
        return false;
      }
    );

    $(".health-conditions-component .add-record-button")
      .off("click")
      .on("click", function (e) {
        var key = $(this)
          .closest(".health-conditions-component")
          .attr("data-attr-key");

        initConditionSearch();
        initConditionDataClicks();

        $(".health-conditions-component .input-errors").html("");
        $('.condition-edit-modal[data-attr-key="' + key + '"]').modal("show");

        //clear the form ready to be populated
        $(this)
          .closest(".health-conditions-component")
          .find(".add-edit-record")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".edit-controls")
          .addClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".add-controls, .save-record-button")
          .removeClass("d-none")
          .attr("data-attr-itemkey", "new");

        $(this)
          .closest(".health-conditions-component")
          .find(".remove-record")
          .addClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".save-record-cancel")
          .removeClass("d-none");

        $(this)
          .closest(".health-conditions-component")
          .find(".add-edit-record input, .add-edit-record select")
          .each(function () {
            $(this).val("");
          });

        $(this)
          .closest(".health-conditions-component")
          .find(".add-edit-record textarea")
          .each(function () {
            $(this).val("");
            $(this).html("");
          });

        $(this)
          .closest(".health-conditions-component")
          .find(".my-people-small-mode")
          .addClass("pt-my-people-adding-row");

        var embedKey = 'embed___'+key+'___';
        MyPeople.clearTableKey(embedKey+"diagnosis_provider");

        return false;
      });
  };

  return {
    init: init,
    initConditionSearch: initConditionSearch,
  };
})();
